module.exports = __webpack_public_path__ + "static/media/banner.d5b707bf.png";